var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"message-container"},[(!_vm.isRoomSelected)?_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"col-xs-12"},[_c('RoomNotSelected')],1)],1):_vm._e(),(_vm.isRoomSelected)?_c('ChatContainer',{attrs:{"act":_vm.act,"topic":_vm.topic,"detailClass":_vm.detailClass}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }